module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/164-croatia-454da6fb397f75d2afd5402db55dbd3e.svg";